class StickyImageOverlay {
  constructor() {
    this.sections = document.querySelectorAll('.sticky-image-overlay');
    this.init();
  }

  init() {
    if (this.sections.length === 0) return;
    
    // Check if user prefers reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    
    this.setupParallax();
    this.bindEvents();
  }

  setupParallax() {
    this.rafId = null;
    this.ticking = false;
  }

  bindEvents() {
    window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
  }

  handleScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.updateParallax();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  updateParallax() {
    const scrollY = window.pageYOffset;
    const windowHeight = window.innerHeight;

    this.sections.forEach((section) => {
      const sectionRect = section.getBoundingClientRect();
      const sectionTop = sectionRect.top + scrollY;
      const sectionHeight = sectionRect.height;
      
      // Check if section is in viewport
      if (sectionRect.bottom < 0 || sectionRect.top > windowHeight) return;
      
      // Calculate scroll progress through the section (0 to 1)
      const scrollProgress = Math.max(0, Math.min(1, 
        (scrollY - sectionTop) / (sectionHeight - windowHeight)
      ));
      
      // Move text content from top to bottom based on scroll progress
      const content = section.querySelector('.sticky-image-overlay__content');
      if (content) {
        const maxTravel = windowHeight - content.offsetHeight - 80; // 80px buffer
        const travelDistance = scrollProgress * maxTravel;
        content.style.top = `${Math.max(20, travelDistance)}px`;
      }
      
      // Subtle parallax effect on image
      const image = section.querySelector('.sticky-image-overlay__image');
      if (image) {
        const imageParallax = scrollProgress * -30;
        image.style.transform = `translateY(${imageParallax}px) scale(1.05)`;
      }
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new StickyImageOverlay();
});

// Re-initialize for dynamic content (theme editor, etc.)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.sticky-image-overlay')) {
    new StickyImageOverlay();
  }
});